module.exports = __webpack_public_path__ + "img/lookbook_11_center.7dee3889.png";